import { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, IndianRupee, Settings as SettingsIcon, LogOut } from "lucide-react";
import { api } from "@/lib/api";

const NAV = [
  { to: "/admind/panel", label: "Home", icon: LayoutDashboard, end: true, testid: "nav-home" },
  { to: "/admind/panel/customers", label: "Customers", icon: Users, testid: "nav-customers" },
  { to: "/admind/panel/payments", label: "Payments", icon: IndianRupee, testid: "nav-payments" },
  { to: "/admind/panel/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!sessionStorage.getItem("floxora_admin_token")) {
      navigate("/admind");
      return;
    }
    api.get("/auth/me").then((r) => setEmail(r.data.email)).catch(() => {
      sessionStorage.removeItem("floxora_admin_token");
      navigate("/admind");
    });
  }, [navigate]);

  const logout = () => {
    sessionStorage.removeItem("floxora_admin_token");
    navigate("/admind");
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white flex" data-testid="admin-layout">
      {/* Mobile top bar */}
      <div className="lg:hidden fixed top-0 inset-x-0 z-40 bg-[#0a0a0a] border-b border-white/10">
        <div className="flex items-center justify-between px-4 py-3">
          <img src="/logo-text.png" alt="Floxora" className="h-6" />
          <button onClick={logout} data-testid="mobile-logout-button" className="text-zinc-400 hover:text-red-400 transition-colors">
            <LogOut className="w-5 h-5" />
          </button>
        </div>
        <nav className="flex gap-1 px-3 pb-2.5 overflow-x-auto">
          {NAV.map((item) => (
            <NavLink
              key={item.to} to={item.to} end={item.end} data-testid={`mobile-${item.testid}`}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs whitespace-nowrap transition-colors ${
                  isActive ? "bg-[#A78BFA]/10 text-[#A78BFA] font-medium" : "text-zinc-400 hover:text-white"
                }`
              }
            >
              <item.icon className="w-3.5 h-3.5" /> {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <aside className="w-60 shrink-0 border-r border-white/10 bg-[#0a0a0a] hidden lg:flex flex-col fixed inset-y-0">
        <div className="p-6 border-b border-white/10">
          <img src="/logo-text.png" alt="Floxora" className="h-10 mb-2" />
          <p className="text-zinc-500 text-xs truncate" data-testid="admin-email-display">{email}</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to} to={item.to} end={item.end} data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm border transition-colors ${
                  isActive ? "bg-[#A78BFA]/10 text-[#A78BFA] font-medium border-[#A78BFA]/30" : "text-zinc-400 hover:text-white hover:bg-white/5 border-transparent"
                }`
              }
            >
              <item.icon className="w-4 h-4" /> {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <button
            onClick={logout} data-testid="logout-button"
            className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-zinc-400 hover:text-red-400 hover:bg-white/5 transition-colors w-full"
          >
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 lg:ml-60 p-4 sm:p-8 lg:p-12 pt-32 lg:pt-12 w-full min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
